<template>
  <login-container>
    <form
      @submit.prevent="login"
      @input="error.errorMessage = ''"
    >
      <form-floating-input
        v-model="user.userId"
        :error="error"
        name="userId"
        label="아이디"
      ></form-floating-input>
      <form-floating-input
        v-model="user.password"
        :error="error"
        name="password"
        label="비밀번호"
        type="password"
      ></form-floating-input>

      <div class="pt--12px">
        <checkbox
          label="로그인 상태유지"
          v-model="user.alwaysLogin"
        ></checkbox>
      </div>

      <!-- <a href="http://127.0.0.1:8000/api/auth/login/naver">
        <img
          src="../../../static/img/naver.png"
          class="btn"
          alt=""
        ></a> -->

      <div class="pt--32px pb--24px">
        <form-button
          type="submit"
          label="LOGIN"
          class="btn btn--block btn--xxxl black text--white"
        ></form-button>
      </div>

      <div class="find-group clearfix">
        <a
          @click="$router.push({name: 'findId'})"
          class="find__id mr--12px"
        >아이디찾기</a>
        <a
          @click="$router.push({name: 'findPwd'})"
          class="find__pw"
        >비밀번호찾기</a>
        <a
          @click="$router.push({name: 'signUp'})"
          class="btn--join float--right"
        >회원가입</a>

      </div>
    </form>

  </login-container>
</template>

<script>
export default {
  data () {
    return {
      user: {
        userId: '',
        password: '',
        alwaysLogin: false
      },
      error: {}
    }
  },
  methods: {
    async login () {
      try {
        await this.$http.post('/api/auth/login', this.user)
        this.$router.push({ name: 'home' })
      } catch (ex) {
        if (ex.response) {
          const { fieldId, errorMessage } = ex.response.data
          this.error = { fieldId, errorMessage }
        }
        console.log('err', ex.response.data)
      } finally {
        this.$store.dispatch('GET_ME')
      }
    },
    async naver () {
      try {
        const res = await this.$http.get('/api/auth/login/naver', { headers: { 'Access-Control-Allow-Origin': '*' } })
        console.log('----------', res.data.location, '-----------')
      } catch (err) {
        console.log('----------', err)
      }
    }
  },
  components: {
    LoginContainer: () => import('@/component/container/LoginContainer'),
    FormFloatingInput: () => import('@/component/ui2/form/FormFloatingInput'),
    Checkbox: () => import('@/component/ui2/form/FormCheckbox'),
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
